module.exports = __webpack_public_path__ + "static/media/loading.85ddd809.gif";